import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, Drawer, IconButton, Typography } from '@mui/material'

export enum AnchorPoint {
    RIGHT = 'right',
    LEFT = 'left',
    TOP = 'top',
    BOTTOM = 'bottom',
}

interface Props {
    children: JSX.Element
    anchorPoint: AnchorPoint
    title: string
    drawerOpen: boolean
    setDrawerOpen: (arg: boolean) => void
    onClearFilters: () => void
    onApplyFilters: () => void
}

export const SidebarWrapper = ({
    children,
    anchorPoint,
    title,
    drawerOpen,
    setDrawerOpen,
    onClearFilters,
    onApplyFilters,
}: Props) => {
    return (
        <Drawer anchor={anchorPoint} open={drawerOpen} onClose={() => setDrawerOpen(false)}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    height: '72px',
                    padding: '25px',
                    boxShadow: '1px 1px 6px rgba(0, 0, 0, 0.3)',
                    zIndex: 1301,
                }}
            >
                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                    {title}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton data-test="close-filter-sidebar-button" onClick={() => setDrawerOpen(false)}>
                        <CloseIcon sx={{ color: 'rgba(0, 111, 214, 1)' }} />
                    </IconButton>
                </Box>
            </Box>
            <Box
                sx={{
                    height: '100%',
                    maxWidth: '352px',
                    backgroundColor: '#f3f4f9ac',
                    overflowY: 'scroll',
                    padding: '25px',
                }}
            >
                {children}
            </Box>
            <Box
                sx={{
                    padding: '16px',
                    height: '72px',
                    marginTop: 'auto',
                    borderTop: '1px solid rgba(209, 209, 209, 1)',
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Button
                    data-test="clear-filters-button"
                    onClick={() => {
                        onClearFilters()
                    }}
                    variant="outlined"
                    size="large"
                    sx={{ width: '146px' }}
                >
                    Clear filters
                </Button>
                <Button
                    data-test="apply-filters-button"
                    onClick={() => {
                        onApplyFilters()
                    }}
                    variant="contained"
                    size="large"
                    color="primary"
                    sx={{ width: '146px' }}
                >
                    Apply filters
                </Button>
            </Box>
        </Drawer>
    )
}
